import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Story } from '../../schemas/story.js';

import { toPointer } from '../../core/issues.js';

export const nodesUnique: Rule<Story> = {
  code: 'story.nodes.duplicateId',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];
    if (!Array.isArray(input.nodes)) {
      return issues;
    }

    const seen = new Set<string>();
    input.nodes.forEach((node, idx) => {
      const id = node?.id;
      if (typeof id !== 'string' || id.length === 0) {
        return;
      }
      if (seen.has(id)) {
        const path: (string | number)[] = ['nodes', idx, 'id'];
        issues.push({
          code: 'story.nodes.duplicateId',
          severity: 'error',
          message: `Duplicate node ID: ${id}`,
          path,
          pointer: toPointer(path),
          locator: { nodeId: id },
          currentValue: id,
          constraint: { kind: 'unique', detail: 'DUPLICATE_NODE_ID' },
        });
      }
      else {
        seen.add(id);
      }
    });

    return issues;
  },
};
